import i18n from '../../../i18n.js';
import CqlValue from '../value.js';
import CqlOperator from './operator';

export default class CqlComparisonOperator extends CqlOperator {

  constructor(operator, pred = null, obj = null) {
    super(operator, [pred, obj]);
  }

  clone(value) {
    return new this.constructor(this.operator, this.args[0], value);
  }

  static create(pred, op, obj) {
    if (["=", "==", "==="].includes(op)) {
      return new CqlEqual(pred, obj);
    }
    else if (["<>", "!=", "!==", "≠"].includes(op)) {
      return new CqlNotEqual(pred, obj);
    }
    else if ([">=", "≥"].includes(op)) {
      return new CqlGreaterThanEqual(pred, obj);
    }
    else if (op === ">") {
      return new CqlGreaterThan(pred, obj);
    }
    else if (["<=", "≤"].includes(op)) {
      return new CqlLessThanEqual(pred, obj);
    }
    else if (op === "<") {
      return new CqlLessThan(pred, obj);
    }
    else if (op.toLowerCase() === "like") {
      return new CqlLike(pred, obj);
    }
    else if (op.toLowerCase() === "between") {
      return new CqlBetween(pred, obj);
    }
  }

}

export class CqlEqual extends CqlComparisonOperator {

  static SYMBOL = "=";

  constructor(pred = null, obj = null) {
    super(CqlEqual.SYMBOL, pred, obj);
  }

  static get longLabel() {
    return i18n.global.t('search.equalTo');
  }

}

export class CqlNotEqual extends CqlComparisonOperator {

  static SYMBOL = "<>";

  constructor(pred = null, obj = null) {
    super(CqlNotEqual.SYMBOL, pred, obj);
  }

  static get label() {
    return "≠";
  }

  static get longLabel() {
    return i18n.global.t('search.notEqualTo');
  }

}

export class CqlGreaterThan extends CqlComparisonOperator {

  static SYMBOL = ">";

  constructor(pred = null, obj = null) {
    super(CqlGreaterThan.SYMBOL, pred, obj);
  }

  static get longLabel() {
    return i18n.global.t('search.greaterThan');
  }

}

export class CqlGreaterThanEqual extends CqlComparisonOperator {

  static SYMBOL = ">=";

  constructor(pred = null, obj = null) {
    super(CqlGreaterThanEqual.SYMBOL, pred, obj);
  }

  static get label() {
    return "≥";
  }

  static get longLabel() {
    return i18n.global.t('search.greaterThanEqual');
  }

}

export class CqlLessThan extends CqlComparisonOperator {

  static SYMBOL = "<";

  constructor(pred = null, obj = null) {
    super(CqlLessThan.SYMBOL, pred, obj);
  }

  static get longLabel() {
    return i18n.global.t('search.lessThan');
  }

}

export class CqlLessThanEqual extends CqlComparisonOperator {

  static SYMBOL = "<=";

  constructor(pred = null, obj = null) {
    super(CqlLessThanEqual.SYMBOL, pred, obj);
  }

  static get label() {
    return "≤";
  }

  static get longLabel() {
    return i18n.global.t('search.lessThanEqual');
  }
  
}

/* export class CqlIsNull extends CqlComparisonOperator {
  
  constructor(pred = null) {
    super("IS NULL", pred);
  }

} */

export class CqlLike extends CqlComparisonOperator {

  static SYMBOL = "like";

  constructor(pred = null, obj = null) {
    super(CqlLike.SYMBOL, pred, obj);
  }

  static get label() {
    return "~";
  }

  static get longLabel() {
    return i18n.global.t('search.matches');
  }

  static get description() {
    return i18n.global.t('search.likeOperatorDescription');
  }

}

export class CqlBetween extends CqlComparisonOperator {

  static SYMBOL = "between";

  constructor(pred = null, obj = []) {
    super(CqlBetween.SYMBOL, pred, obj);
  }

  static get label() {
    return "≥ … ≤";
  }

  static get longLabel() {
    return i18n.global.t('search.between');
  }

  static get description() {
    return i18n.global.t('search.betweenOperatorDescription');
  }

  toText() {
    const bounds = this.args[1];
    return `${this.args[0].toText()} BETWEEN ${bounds[0].toText()} and ${bounds[1].toText()}`;
  }

  static valueType() {
    return CqlBetween;
  }

  static getDefaultValue(queryable) {
    return [
      CqlValue.create(queryable.defaultValue),
      CqlValue.create(queryable.defaultValue)
    ];
  }

}
